const SlackIntegration = {

    postCommentToChannel: async (issueObj) => {
        const SLACK_API_BASE_URL = "https://hooks.slack.com/services/";
        const SLACK_URL_TOKEN = process.env.REACT_APP_SLACK_URL_TOKEN;

        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                "text": JSON.stringify(issueObj)
            })
        };

        let response = await fetch(SLACK_API_BASE_URL + SLACK_URL_TOKEN, requestOptions)
        .catch((error) => {
            console.log("Error communicating with Slack API: " + error);
        });

        let data = await response.text();

        return data;
    }

};


export default SlackIntegration;